<template>
  <div>
    <div v-if="loading" class="text-center">
      <h1 class="font-bold text-2xl">Loading...</h1>
    </div>

    <div v-else-if="error" class="text-center">
      <h1 class="font-bold text-2xl">Something went wrong...</h1>
    </div>

    <ul v-else-if="result && result.recipes.length > 0">

        <li v-for="recipe in result.recipes" :key="recipe.id">
          <RecipesCard
              :title="recipe.name"
              :id=recipe.id
              :image=recipe.image
              :created-at=recipe.createdAt
              :instruction=recipe.instruction />
        </li>
    </ul>

    <div v-else class="text-center">
      <h2 class="font-bold text-8xl mt-8 text-gray-500">🥪</h2>
      <h2 class="font-bold text-xl mt-8 text-gray-500"> No Recipes Found </h2>
    </div>

  </div>
</template>

<script>

// import { watch, ref} from "vue"
import gql from 'graphql-tag'
import { watch } from 'vue'
import { useQuery } from '@vue/apollo-composable'
import RecipesCard from "@/components/RecipesCard";




const RECIPES_QUERY = gql`
  query getRecipes {
    recipes {
      id
      image
      name
      createdAt
      instruction
    }
  }
`
export default {
  components: {RecipesCard},
  data () {
    return {
    }
  },
  setup() {
    const {result,error,loading} = useQuery(RECIPES_QUERY,null, {pollInterval: 250})
    watch(() => {
      console.log(result.value)
    })

    return {
      result,
      error,
      loading
    }
  },

}
</script>

<style scoped>

</style>